class EnvironmentNode {
  constructor({ uid, namespace, envImplementation, props }) {
    this.uid = uid;
    this.namespace = namespace;
    this.envImplementation = envImplementation;
    this.props = props;
  }
}

export { EnvironmentNode };
